import {insertAfter} from '../common/utils'
import {liveBind} from 'evite'
// TODO - refactor (seems only site_warning is used)
export default class HeaderNavView {
    constructor() {
        this.el = document.querySelector('body');
        liveBind(this.el, 'touchstart', '#searchIcon', this.run_search);
        liveBind(this.el, 'click', '#searchIcon', this.run_search);
    };

    run_search = (event) => {
        event.target.closest('form').submit();
    };


    site_warning (message) {
        const div = document.createElement('div');
        div.classList.add('site-warning');
        div.innerHTML = message;
        insertAfter(div, document.getElementById('header').firstChild)
    };

};



// WEBPACK FOOTER //
// ./assets/es6/nav/search_icon.es6